module.exports = __webpack_public_path__ + "static/media/logo_multic2.30e8f788.png";